export const config = {
  APP_ENV: process.env.APP_ENV,
  GOOGLE_RECAPTCHA_SITE_V3: process.env.GOOGLE_RECAPTCHA_SITE_V3,
  PROJECT_TYPE: process.env.PROJECT_TYPE,
  PAGAR_ME_PUBLIC_KEY: process.env.PAGAR_ME_PUBLIC_KEY,
  CELCASH_PUBLIC_TOKEN: process.env.CELCASH_PUBLIC_TOKEN,
  DISPUTE_URL: process.env.DISPUTE_URL,
  ENABLE_ALPHANUMERIC_CNPJ: process.env.ENABLE_ALPHANUMERIC_CNPJ,
  MUI_LICENSE_KEY: process.env.MUI_LICENSE_KEY,
  ISPB: process.env.ISPB || '54811417',
  COMPREFACE_URL: process.env.COMPREFACE_URL || 'http://localhost',
  COMPREFACE_PORT: process.env.COMPREFACE_PORT || 443,
  COMPREFACE_SERVICE_DETECTION_KEY:
    process.env.COMPREFACE_SERVICE_DETECTION_KEY ||
    '00000000-0000-0000-0000-000000000003',
  COMPREFACE_SERVICE_VERIFICATION_KEY:
    process.env.COMPREFACE_SERVICE_VERIFICATION_KEY,
  COMPREFACE_SERVICE_RECOGNITION_KEY:
    process.env.COMPREFACE_SERVICE_RECOGNITION_KEY,
  FINGERPRINT_VERIFY: process.env.FINGERPRINT_VERIFY || 'false',
};
